/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CustomLayout from "../../Core/Layout/CustomLayout";
import KPIs from "./KPIs";
import HubHeader from "./HubHeader";
// import { TIME_FILTER } from "./constants";
import GridView from "./GridView";
// import ModuleTimeFilter from "./ModuleTimeFilter";
import TableView from "./TableView";
import useDebounce from "../../Core/hooks/useDebounce";
import { getEnergyBreakdown, getHubKPIs } from "../../Redux/APIs/hubAPI";

const LOCAL_DEFAULT_LIMIT = 10;

const HubScreen = () => {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const selectedView = searchParams.get("view");

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("asc");

  // const [moduleTimeFilter, setModuleTimeFilter] = useState({
  //   id: TIME_FILTER.TODAY,
  //   value: "today",
  //   custom: [],
  // });

  const debounceSearch = useDebounce(search, 500);

  // to set the view
  useEffect(() => {
    if (!searchParams.has("view")) {
      searchParams.set("view", "grid");
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  // fetch the hub kpi
  useEffect(() => {
    dispatch(getHubKPIs());
  }, [dispatch]);

  // fetch the hub list on every page change
  useEffect(() => {
    // default value of 0 and 20 for grid view
    // sort = asc | desc -> changes when clicked on high to low
    const filterObj = {
      limit: 20,
      offset: 0,
      sort,
    };

    if (selectedView === "table") {
      filterObj.offset = ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT;
      filterObj.limit = LOCAL_DEFAULT_LIMIT;
    }

    if (debounceSearch) filterObj.searchQuery = debounceSearch;

    dispatch(getEnergyBreakdown(filterObj));
  }, [dispatch, currentPage, selectedView, debounceSearch, sort]);

  return (
    <CustomLayout pageName="Hubs">
      <div className="relative bg-background w-full h-full">
        <div className="h-[70px] flex items-center justify-between bg-background-white px-6 py-[13px]">
          <p className="font-poppins font-medium text-base">Overview</p>

          {/* <ModuleTimeFilter
            filter={moduleTimeFilter}
            setFilter={setModuleTimeFilter}
          /> */}
        </div>

        <KPIs />

        <HubHeader
          search={search}
          setSearch={setSearch}
          sort={sort}
          setSort={setSort}
        />

        {selectedView === "grid" ? (
          <GridView />
        ) : (
          <TableView
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </CustomLayout>
  );
};

export default HubScreen;
